import { Link, useLocation } from "react-router-dom";
import { Scale, X } from "lucide-react";
import { useCompare } from "../context/CompareContext";

/** Floating pill that appears on any page when at least 1 property is added to compare.
 *  Tapping it opens the /compare page. X clears the selection. */
export default function CompareBar() {
    const { ids, clear } = useCompare();
    const location = useLocation();

    if (ids.length === 0) return null;
    if (location.pathname.startsWith("/compare")) return null; // hide on the compare page itself

    return (
        <div
            className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] pointer-events-none"
            data-testid="compare-bar"
        >
            <div className="pointer-events-auto flex items-center gap-2 px-3 py-2 rounded-full bg-navy-500 text-white shadow-2xl border border-gold-500/40 backdrop-blur-md">
                <Link
                    to="/compare"
                    data-testid="compare-bar-open"
                    className="text-on-image inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold-500 text-navy-900 font-bold text-sm hover:bg-gold-100 transition-colors"
                >
                    <Scale className="w-4 h-4" />
                    Compare
                    <span className="ml-1 inline-flex items-center justify-center min-w-[22px] h-[22px] rounded-full bg-navy-900 text-gold-300 text-[11px] font-bold px-1.5">
                        {ids.length}
                    </span>
                </Link>
                <button
                    type="button"
                    onClick={clear}
                    aria-label="Clear compare selection"
                    data-testid="compare-bar-clear"
                    className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                >
                    <X className="w-4 h-4 text-white" />
                </button>
            </div>
        </div>
    );
}
